import { SET_EMOTION_AROUSAL_SCORE } from "./types";

const setEmotionArousalScore = (emotion, field, value) => async (dispatch) => {
    dispatch({
        type: SET_EMOTION_AROUSAL_SCORE,
        emotion,
        field,
        value,
    });
};

export default setEmotionArousalScore;
